webpackJsonp([29319016969055],{

/***/ 1314:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StockTransferFulfillmentItemStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COLLECTED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"READY"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-stock-transfer-fulfillment-item-status-d4bd9686ab029f0fb7d2.js